/** Turns a wire code such as `workflow_step` into sentence-case copy ("Workflow step"). Never show the raw code. */
export function humanize(code: string): string {
  const spaced = code.replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** Date and time in the viewer's locale, or `empty` when there is no value. */
export function formatDateTime(value: string | null | undefined, empty = 'Never'): string {
  return value ? new Date(value).toLocaleString() : empty;
}
